import { useParams } from "react-router-dom"
import GlobalMediaFields from "routes/Base/Admin/GlobalMediaFields/List"

export default function AgencyClientFields() {
  const { configId } = useParams<{ configId: string }>()
  return (
    <GlobalMediaFields
      configScope="CLIENT_AGENCY_CONFIG"
      configOwnerId={configId}
    />
  )
}
